import { render, staticRenderFns } from "./submenu.vue?vue&type=template&id=95de1864&scoped=true"
import script from "./submenu.vue?vue&type=script&lang=js"
export * from "./submenu.vue?vue&type=script&lang=js"
import style0 from "./submenu.vue?vue&type=style&index=0&id=95de1864&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95de1864",
  null
  
)

export default component.exports